import React from "react";

const PayrollHistory = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="m33.118 26.842-6.755 3.367-.473-7.562 1.53.886C31.646 16.806 30.15 7.953 23.944 3c.98.373 1.92.842 2.809 1.407 7.26 4.607 9.429 14.256 4.836 21.547l1.528.888Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M21.611 9.2a9.49 9.49 0 0 0-3.665-.707 9.527 9.527 0 0 0-6.698 2.795l.211 3.399a.637.637 0 0 1-.96.59l-1.368-.796c-1.996 4.921.358 10.536 5.258 12.534a9.545 9.545 0 0 0 10.364-2.081l-.211-3.398a.613.613 0 0 1 .082-.367.641.641 0 0 1 .877-.23l1.368.797c.48-1.19.711-2.417.711-3.624 0-3.791-2.253-7.39-5.969-8.912Zm3.422 9.553H19.11a1.371 1.371 0 0 1-.467.47A1.283 1.283 0 0 1 17.357 17v-5.956a.639.639 0 1 1 1.28 0v5.949c.198.116.358.276.473.476h5.923a.643.643 0 0 1 0 1.285Z"
            fill={fill}
        />
        <path className="u_fill"
            d="m2.881 9.38 6.755-3.367.474 7.562-1.53-.893c-4.227 6.733-2.73 15.588 3.474 20.54a16.01 16.01 0 0 1-2.808-1.406C1.986 27.203-.184 17.56 4.41 10.267v-.006l-1.529-.88Z"
            fill={fill}
        />
    </svg>
);

export default PayrollHistory;